import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useStoreState } from "pullstate";
import { createContext, useCallback, useEffect, useState } from "react";
import Store from "../../utils/Store";
import { clone, cloneDeep, get, isEmpty, set } from "lodash";
import useWebsocket from "../../hooks/useWebsocket";
import useMedia, { MediaSizes } from "../../hooks/useMedia";
import constants from "../../utils/constants";
import { getIsOnpremise, isValidDate } from "../../utils";
import getPatients from "./services/getPatients";
import getPatientsV2 from "./services/getPatientsV2";
import getCounts from "./services/getCounts";
import getSyncStatus from "./services/getSyncStatus";
import { getEmergencyPatients } from "../WorklistTagsSetting/services";
import { add } from "date-fns";
import getMatchingPatient from "../MatchingPatient/services/getMatchingPatient";
import { downloadFile } from "../ExportMessage/services/downloadService";
import { useRouter } from "next/router";
import useCheckWorklistContainer from "../../hooks/useCheckWorklistContainer";
import useCheckLCContainer from "../../hooks/useCheckLCContainer";
import getPatientDetails from "./services/getPatientDetails";
import Toast from "../Toast";
import getEnv from "../../utils/getEnv";
import getCloudSyncStatus from "./services/getCloudSyncStatus";
import getPatientTags from "./services/getPatientTags";
import useSuggestedNextSteps from "./services/useSuggestedNextSteps";
import { SORT_BY_MAP, SORT_ORDER_MAP } from "../Worklist/SortControl";
import { useAuth } from "@qure/qure-auth";
import { buildMultiSelectFilterRequest, formatFiltersObj } from "../SearchFilters/utils";
import useWorkspaceTagSettingsService from "../CustomTagsManagement/services/workspaceTagSettingsService";
import useCheckBulkActions from "../../hooks/useCheckBulkActions";
import useWorkspacePermittedData from "../WorkspaceManagement/services/useWorkspacePermittedData";
import getWorkspaceConfig from "../WorkspaceManagement/services/getWorkspaceConfig";
import getFilterPatientsCount from "../Worklist/services/getFilterPatientsCount";
var DEFAULT_SORT_PARAMS = {
  orderBy: SORT_BY_MAP.created_at,
  order: SORT_ORDER_MAP.desc
};
var VALID_ORDER_BY = [SORT_BY_MAP.updated_at, SORT_BY_MAP.created_at, SORT_BY_MAP.reminder];
function parsePersistedSortParams(persisted) {
  if (!persisted) return DEFAULT_SORT_PARAMS;
  try {
    var parsed = JSON.parse(persisted);
    var orderBy = parsed === null || parsed === void 0 ? void 0 : parsed.orderBy;
    if (!orderBy || !VALID_ORDER_BY.includes(orderBy)) {
      return DEFAULT_SORT_PARAMS;
    }
    var order = (parsed === null || parsed === void 0 ? void 0 : parsed.order) === SORT_ORDER_MAP.asc || (parsed === null || parsed === void 0 ? void 0 : parsed.order) === SORT_ORDER_MAP.desc ? parsed.order : SORT_ORDER_MAP.desc;
    // Reminder sort is only used with ascending order
    if (orderBy === SORT_BY_MAP.reminder && order !== SORT_ORDER_MAP.asc) {
      return DEFAULT_SORT_PARAMS;
    }
    return {
      orderBy: orderBy,
      order: order
    };
  } catch (_unused) {
    return DEFAULT_SORT_PARAMS;
  }
}
export var PatientsContext = /*#__PURE__*/createContext({});
export var PatientsContextProvider = function PatientsContextProvider(props) {
  var _localStorage, _localStorage2, _localStorage3, _localStorage4, _localStorage5;
  var children = props.children;
  var pageSize = constants.PAGE_SIZE;
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var user = get(userInfo, ["details"], null);
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        newPatientId: s.newPatientId,
        worklistCloudSyncStatus: s.worklistCloudSyncStatus,
        isWorklistCollapsed: s.isWorklistCollapsed,
        isSummaryCollapsed: s.isSummaryCollapsed
      };
    }),
    newPatientId = _useStoreState.newPatientId,
    worklistCloudSyncStatus = _useStoreState.worklistCloudSyncStatus,
    isWorklistCollapsed = _useStoreState.isWorklistCollapsed,
    isSummaryCollapsed = _useStoreState.isSummaryCollapsed;
  var userId = get(userInfo, ["username"], "");
  var isLoggedIn = !isEmpty(user);
  var _useState = useState(""),
    lastId = _useState[0],
    setLastId = _useState[1];
  var _useState2 = useState(null),
    patientsData = _useState2[0],
    setPatientsData = _useState2[1];
  var _useState3 = useState({}),
    updatedMessage = _useState3[0],
    setUpdatedMessage = _useState3[1];
  var _useState4 = useState({}),
    unreadMessages = _useState4[0],
    setUnreadMessages = _useState4[1];
  var _useState5 = useState({}),
    currentPatient = _useState5[0],
    setCurrentPatient = _useState5[1];
  var _useState6 = useState(false),
    isPatientsLoading = _useState6[0],
    setPatientsLoading = _useState6[1];
  var _useState7 = useState(false),
    worklistUpdated = _useState7[0],
    setWorklistUpdated = _useState7[1];
  var _useState8 = useState(0),
    count = _useState8[0],
    setCount = _useState8[1];
  var _useState9 = useState([]),
    emergencyPatients = _useState9[0],
    setEmergencyPatients = _useState9[1];
  // default data to be reverted after API is implemented
  var _useState0 = useState(null),
    nextSteps = _useState0[0],
    setNextSteps = _useState0[1];
  // const [unsyncCount, setUnsyncCount] = useState(0);
  var _useState1 = useState(false),
    isCountLoading = _useState1[0],
    setIsCountLoading = _useState1[1];
  var _useState10 = useState(null),
    selectedWorkspace = _useState10[0],
    setSelectedWorkspace = _useState10[1];
  var _persistedSortParams = (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem(constants.PERSISTED.sortParams);
  var _useState11 = useState(parsePersistedSortParams(_persistedSortParams)),
    sortParams = _useState11[0],
    setSortParams = _useState11[1];
  var _useState12 = useState(get(userInfo, ["pending_referrals"], [])),
    pendingReferral = _useState12[0],
    setPendingReferral = _useState12[1];
  var _useState13 = useState(get(userInfo, ["pending_requests"], [])),
    pendingRequest = _useState13[0],
    setPendingRequest = _useState13[1];
  var filterList = get(userInfo, ["settings", "saved_filters"], []);
  var _useState14 = useState(filterList),
    savedFilters = _useState14[0],
    setSavedFilters = _useState14[1];
  var defaultFilterIds = get(userInfo, ["settings", "default_filters"], []);
  var _persistedFilters = (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.getItem(constants.PERSISTED.filterObj);
  var _filters = clone(_persistedFilters ? JSON.parse(_persistedFilters) : constants.DEEFAULT_FILTER);
  if (!isEmpty(defaultFilterIds)) {
    var labels = [];
    var defaultFiltersPayload = filterList.reduce(function (acc, filterItem) {
      if (defaultFilterIds.some(function (defaultId) {
        return String(defaultId) === String(filterItem.id) || Number(defaultId) === Number(filterItem.id);
      })) {
        acc.push({
          id: filterItem.id,
          values: filterItem.filter
        });
        labels.push(filterItem.name);
      }
      return acc;
    }, []);
    var persistedSavedFilters = _filters["selectedFilters"] || [];
    _filters.isFilterApplied = true;
    _filters["selectedFilters"] = [].concat(_toConsumableArray(persistedSavedFilters), _toConsumableArray(defaultFiltersPayload));
    _filters.label = labels.join("");
  }
  var _useState15 = useState(_filters),
    filters = _useState15[0],
    setFilters = _useState15[1];
  var isLCWorklist = useCheckLCContainer();
  var currentPatientUid = get(currentPatient, ["patient_uid"], 0);
  var isBulkActions = useCheckBulkActions();
  var isPatientsPage = useCheckWorklistContainer();
  var suggestedNextSteps = useSuggestedNextSteps((selectedWorkspace === null || selectedWorkspace === void 0 ? void 0 : selectedWorkspace.value) || 0, currentPatientUid || 0);
  var _persistedSavedFilters = (_localStorage3 = localStorage) === null || _localStorage3 === void 0 ? void 0 : _localStorage3.getItem(constants.PERSISTED.savedFilterData);
  var _useState16 = useState(_persistedSavedFilters ? JSON.parse(_persistedSavedFilters) : null),
    savedFilterData = _useState16[0],
    setSavedFilterData = _useState16[1];
  var _persistedFullWidthWorklist = (_localStorage4 = localStorage) === null || _localStorage4 === void 0 ? void 0 : _localStorage4.getItem(constants.PERSISTED.isFullWidthWorklist);
  var _useState17 = useState(!!_persistedFullWidthWorklist),
    isFullWidthWorklist = _useState17[0],
    setIsFullWidthWorklist = _useState17[1];
  var _persistedWorklistCollapsed = (_localStorage5 = localStorage) === null || _localStorage5 === void 0 ? void 0 : _localStorage5.getItem(constants.PERSISTED.isWorklistCollapsed);
  var _useState18 = useState([]),
    matchingPatients = _useState18[0],
    setMatchingPatients = _useState18[1];
  // Track if default filters have been applied (shared across all components)
  var _useState19 = useState(false),
    hasAppliedDefaultFilters = _useState19[0],
    setHasAppliedDefaultFilters = _useState19[1];
  // Track if filters were explicitly cleared by user (to prevent auto-reapplying defaults)
  var _useState20 = useState(false),
    filtersExplicitlyCleared = _useState20[0],
    setFiltersExplicitlyCleared = _useState20[1];
  var _useState21 = useState([]),
    patientTags = _useState21[0],
    setPatientTags = _useState21[1];
  var _useState22 = useState(false),
    isPatientTagsLoading = _useState22[0],
    setIsPatientTagsLoading = _useState22[1];
  var _useState23 = useState([]),
    remindersData = _useState23[0],
    setRemindersData = _useState23[1];
  var _useState24 = useState(null),
    wsSummaryData = _useState24[0],
    setWsSummaryData = _useState24[1];
  var _useState25 = useState(null),
    emrRecordsData = _useState25[0],
    setEmrRecordsData = _useState25[1];
  var _useState26 = useState(0),
    firstPatientUid = _useState26[0],
    setFirstPatientUid = _useState26[1];
  // Fetch custom fields for the selected workspace to determine tag types
  var _ref = useWorkspaceTagSettingsService(selectedWorkspace === null || selectedWorkspace === void 0 ? void 0 : selectedWorkspace.value),
    customFields = _ref.data;
  var isLC = process.env.NEXT_PUBLIC_IS_LC === "true";
  var _useWebsocket = useWebsocket("/worklist/".concat(userId, "/"), !isEmpty(user)),
    socket = _useWebsocket.socket,
    wsData = _useWebsocket.wsData,
    isWSConnectionOpen = _useWebsocket.isWSConnectionOpen;
  var router = useRouter();
  var isMobile = useMedia([MediaSizes.MOBILE], [true], false);
  var isOnPremise = getIsOnpremise();
  var isFormModalOpen = getEnv("NEXT_PUBLIC_OPEN_FORM_MODAL_AFTER_REGISTRATION") === "true";
  var _useWorkspacePermitte = useWorkspacePermittedData(true, constants.WORKSPACE_USER_ROLES.WORKSPACE_PATIENT_WRITE, {
      show_bulk_tagging_status: true
    }),
    workspaceData = _useWorkspacePermitte.data,
    isLoadingWorkspaces = _useWorkspacePermitte.isLoading,
    refetchUserWorkspace = _useWorkspacePermitte.refetch;
  var getPatientData = function getPatientData() {
    var apiConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var params;

    // For LC, always use the new MultiSelectFilterRequest structure
    if (isLC) {
      // Get the array of selected filters (could be single or multiple)
      // filters.selectedFilters should be an array of objects with { id, values }
      var selectedFilters = (filters === null || filters === void 0 ? void 0 : filters.selectedFilters) || [];
      var filtersArray = _toConsumableArray(selectedFilters);
      if (savedFilterData) {
        filtersArray.push({
          values: savedFilterData
        });
      }
      // Map sort_by from SORT_BY_MAP to the new structure
      var sortByValue = "study";
      if (sortParams.orderBy === SORT_BY_MAP.updated_at) {
        sortByValue = "recent";
      } else if (sortParams.orderBy === SORT_BY_MAP.created_at) {
        sortByValue = "created";
      } else if (sortParams.orderBy === SORT_BY_MAP.reminder) {
        sortByValue = "reminder";
      }

      // Use new MultiSelectFilterRequest structure
      // Pass specialCustomTagIds from filters state to convert program_type, ai_recommendation, manual_review to custom tags
      params = buildMultiSelectFilterRequest(filtersArray, {
        logic: filters.multiSelectLogic || "AND",
        page_size: pageSize,
        sort_by: sortByValue,
        sort_order: sortParams.order || "desc",
        pagination_id: lastId ? Number(lastId) : null,
        page: "next",
        unread_messages: filters.unread_messages || false,
        only_counts: false,
        search: get(filters, ["data", "search"], ""),
        selectedWorkspace: selectedWorkspace,
        specialTagIds: filters.specialCustomTagIds || null,
        customFields: customFields || null
      });
    } else {
      // Use existing structure (backward compatible for non-LC)
      var filterParams = getFilterParams(filters);
      params = _objectSpread({
        page_size: pageSize
      }, filterParams);
      if (sortParams.order) {
        params.sort_order = sortParams.order;
        params.sort_by = sortParams.orderBy;
      }
      if (lastId) {
        params.pagination_id = lastId;
      }
    }
    setPatientsLoading(true);
    // Use v2 endpoint for LC, original endpoint for non-LC
    var getPatientsService = isLC ? getPatientsV2 : getPatients;
    getPatientsService(params, patientsData, apiConfig).then(/*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_patientsData) {
        var _emergencyPatients, _emergencyPatientsData, workListContainer, patient_uid, _patientsData$data, firstPatient, nextRoute, _updatedPatients;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _emergencyPatients = [];
              if (lastId) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return getEmergencyPatients();
            case 1:
              _emergencyPatientsData = _context.v;
              workListContainer = document.getElementById("worklist-container");
              _emergencyPatients = get(_emergencyPatientsData, ["data", "content"], []);
              setEmergencyPatients(_emergencyPatients);
              patient_uid = Number(get(router, ["query", "params", "0"], 0));
              if (isPatientsPage && (!patient_uid || filters.isFilterApplied)) {
                firstPatient = _patientsData === null || _patientsData === void 0 || (_patientsData$data = _patientsData.data) === null || _patientsData$data === void 0 || (_patientsData$data = _patientsData$data.content) === null || _patientsData$data === void 0 ? void 0 : _patientsData$data[0];
                nextRoute = "/patients";
                if (firstPatient) {
                  nextRoute += "/".concat(firstPatient.patient_uid);
                  setCurrentPatient(firstPatient);
                  setFirstPatientUid(firstPatient.patient_uid);
                  if (workListContainer) {
                    workListContainer["scrollTop"] = 0;
                  }
                } else {
                  setCurrentPatient({});
                }
                router.replace(nextRoute, undefined, {
                  shallow: true
                });
              }
              if (isBulkActions && workListContainer) {
                workListContainer["scrollTop"] = 0;
              }
              _context.n = 3;
              break;
            case 2:
              _emergencyPatients = emergencyPatients;
            case 3:
              _updatedPatients = updatePatientList(_patientsData || patientsData, _emergencyPatients);
              setPatientsData(_updatedPatients);
              setPatientsLoading(false);
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }())["catch"](function (e) {
      setPatientsLoading(false);
    });
  };
  var getPatientsCountV2Payload = function getPatientsCountV2Payload() {
    // Get the array of selected filters (could be single or multiple)
    // filters.selectedFilters should be an array of objects with { id, values }
    var selectedFilters = (filters === null || filters === void 0 ? void 0 : filters.selectedFilters) || [];
    var filtersArray = _toConsumableArray(selectedFilters);
    if (savedFilterData) {
      filtersArray.push({
        values: savedFilterData
      });
    }

    // Use new MultiSelectFilterRequest structure with only_counts: true
    // Pass specialCustomTagIds from filters state to convert program_type, ai_recommendation, manual_review to custom tags
    return buildMultiSelectFilterRequest(filtersArray, {
      logic: filters.multiSelectLogic || "AND",
      page_size: 0,
      sort_by: "study",
      sort_order: "desc",
      pagination_id: null,
      page: "next",
      unread_messages: filters.unread_messages || false,
      only_counts: true,
      search: get(filters, ["data", "search"], ""),
      selectedWorkspace: selectedWorkspace,
      specialTagIds: filters.specialCustomTagIds || null,
      customFields: customFields || null
    });
  };
  var getPatientCount = function getPatientCount() {
    var params;
    setIsCountLoading(true);

    // For LC, use v2 endpoint with only_counts: true, otherwise use counts endpoint
    if (isLC) {
      params = getPatientsCountV2Payload();
      getPatientsV2(params, {}, {}).then(function (data) {
        var count = get(data, ["data", "count"], 0);
        setCount(count);
        setIsCountLoading(false);
      })["catch"](function () {
        setCount(0);
        setIsCountLoading(false);
      });
    } else {
      params = getFilterParams(filters);
      getCounts(params).then(function (_count) {
        setCount(_count);
        setIsCountLoading(false);
      })["catch"](function () {
        setCount(0);
        setIsCountLoading(false);
      });
    }
  };
  var getSavedFiltersCount = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(affectedFilters) {
      var _savedFilters;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            if (!!savedFilters && (savedFilters === null || savedFilters === void 0 ? void 0 : savedFilters.length) > 0 && selectedWorkspace) {
              _savedFilters = clone(savedFilters) || [];
              _savedFilters.forEach(/*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(filter) {
                  var _filter, filterData, startDate, endDate, startDateVal, endDateVal, data, savedFilterToUpdateIdx, _t;
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.p = _context2.n) {
                      case 0:
                        if (!(!isEmpty(affectedFilters) && !(affectedFilters !== null && affectedFilters !== void 0 && affectedFilters.includes(filter.id)))) {
                          _context2.n = 1;
                          break;
                        }
                        return _context2.a(2);
                      case 1:
                        _filter = clone(filter);
                        filterData = formatFiltersObj(_filter.filter || {});
                        if (filterData !== null && filterData !== void 0 && filterData.start_study_date) {
                          startDate = get(filterData, ["start_study_date"], "");
                          endDate = get(filterData, ["end_study_date"], "");
                          startDateVal = new Date(startDate);
                          endDateVal = add(new Date(endDate), {
                            days: 1
                          });
                          if (isValidDate(startDateVal) && isValidDate(endDateVal)) {
                            startDateVal.setHours(0, 0, 0);
                            endDateVal.setHours(0, 0, 0);
                            set(filterData, ["start_study_date"], startDateVal.toISOString());
                            set(filterData, ["end_study_date"], endDateVal.toISOString());
                          }
                        }
                        // Only set source to selectedWorkspace if no sites are selected in filters
                        if (!filterData.source || filterData.source === "") {
                          set(filterData, ["source"], selectedWorkspace === null || selectedWorkspace === void 0 ? void 0 : selectedWorkspace.id);
                        }
                        _context2.p = 2;
                        _context2.n = 3;
                        return getFilterPatientsCount(_objectSpread({
                          page_size: 0
                        }, filterData), _filter.name, _filter.filter, _filter.id, selectedWorkspace, true // isAlreadyFormatted - data is already formatted from profile counts call
                        );
                      case 3:
                        data = _context2.v;
                        _filter.count = get(data, ["count"], 0);
                        _context2.n = 5;
                        break;
                      case 4:
                        _context2.p = 4;
                        _t = _context2.v;
                      case 5:
                        savedFilterToUpdateIdx = _savedFilters.findIndex(function (sf) {
                          return sf.id == _filter.id;
                        });
                        if (savedFilterToUpdateIdx >= 0) {
                          _savedFilters[savedFilterToUpdateIdx].count = _filter.count;
                        }
                        setSavedFilters(_savedFilters);
                      case 6:
                        return _context2.a(2);
                    }
                  }, _callee2, null, [[2, 4]]);
                }));
                return function (_x3) {
                  return _ref4.apply(this, arguments);
                };
              }());
            }
          case 1:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function getSavedFiltersCount(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  useEffect(function () {
    getSavedFiltersCount();
  }, [selectedWorkspace]);
  useEffect(function () {
    var _workspaceData$filter, _listSource$find;
    if (isLoadingWorkspaces) return;
    var listSource = workspaceData === null || workspaceData === void 0 || (_workspaceData$filter = workspaceData.filter(function (src) {
      return !src.data_hidden;
    })) === null || _workspaceData$filter === void 0 ? void 0 : _workspaceData$filter.map(function (src) {
      return {
        label: src.name,
        value: src.id,
        id: src.uuid,
        role: src.role,
        has_permission: src.has_permission,
        synced: src.synced
      };
    });
    var defaultWorkspace = (_listSource$find = listSource === null || listSource === void 0 ? void 0 : listSource.find(function (item) {
      return String(item.value) === String(userInfo === null || userInfo === void 0 ? void 0 : userInfo.default_workspace);
    })) !== null && _listSource$find !== void 0 ? _listSource$find : null;
    setSelectedWorkspace(defaultWorkspace);
  }, [isLoadingWorkspaces, workspaceData, userInfo === null || userInfo === void 0 ? void 0 : userInfo.default_workspace]);
  useEffect(function () {
    var workspaceId = selectedWorkspace === null || selectedWorkspace === void 0 ? void 0 : selectedWorkspace.value;
    if (!workspaceId) {
      Store.update(function (s) {
        s.workspaceConfig = null;
      });
      return;
    }
    getWorkspaceConfig(workspaceId).then(function (data) {
      Store.update(function (s) {
        s.workspaceConfig = data;
      });
    })["catch"](function () {
      Store.update(function (s) {
        s.workspaceConfig = null;
      });
    });
  }, [selectedWorkspace === null || selectedWorkspace === void 0 ? void 0 : selectedWorkspace.value]);
  useEffect(function () {
    if (isWSConnectionOpen && firstPatientUid) {
      socket === null || socket === void 0 || socket.send(JSON.stringify({
        action: "subscribe",
        params: {
          patient_uid: firstPatientUid
        }
      }));
      setFirstPatientUid(0);
    }
  }, [isWSConnectionOpen, firstPatientUid]);
  useEffect(function () {
    if (!isEmpty(userInfo) && isLoggedIn) {
      setPendingReferral(userInfo === null || userInfo === void 0 ? void 0 : userInfo.pending_referrals);
      setPendingRequest(userInfo === null || userInfo === void 0 ? void 0 : userInfo.pending_requests);
    }
  }, [userInfo, isLoggedIn]);
  var getPatientCustomTags = function getPatientCustomTags(patientUid) {
    setIsPatientTagsLoading(true);
    getPatientTags(patientUid.toString()).then(function (tags) {
      setPatientTags(Array.isArray(tags) ? tags : []);
      setIsPatientTagsLoading(false);
    })["catch"](function () {
      setIsPatientTagsLoading(false);
    });
  };

  // Only include orderBy in dependencies when order is not null (i.e., sorting is active)
  var activeSortBy = sortParams.order ? sortParams.orderBy : null;
  var controller = null;
  useEffect(function () {
    controller = new AbortController();
    var signal = controller.signal;
    if (isLoggedIn && !isEmpty(selectedWorkspace)) {
      getPatientData({
        signal: signal
      });
    }
  }, [lastId, pageSize, filters, sortParams.order, activeSortBy, selectedWorkspace]);
  useEffect(function () {
    return function () {
      if (controller) {
        controller.abort();
      }
    };
  }, []);
  useEffect(function () {
    /* get total patient count just for display on top on worklist */
    if (isLoggedIn && !isEmpty(selectedWorkspace)) {
      getPatientCount();
    }
  }, [filters, selectedWorkspace]);

  // Persist sort params to localStorage (clears on logout)
  useEffect(function () {
    if (typeof window !== "undefined") {
      localStorage.setItem(constants.PERSISTED.sortParams, JSON.stringify(sortParams));
    }
  }, [sortParams]);
  useEffect(function () {
    if (isOnPremise) {
      if (!isMobile && !isLCWorklist) {
        setIsFullWidthWorklist(true);
      }
      getSyncStatus().then(function (resp) {
        Store.update(function (s) {
          s.worklistSyncStatus = resp;
        });
      });
    } else if (isLoggedIn) {
      getCloudSyncStatus().then(function (resp) {
        Store.update(function (s) {
          s.worklistCloudSyncStatus = resp;
        });
      });
    }
  }, [isOnPremise, isLCWorklist, isLoggedIn]);
  useEffect(function () {
    if (typeof window !== "undefined") {
      if (isWorklistCollapsed) {
        var _localStorage6;
        (_localStorage6 = localStorage) === null || _localStorage6 === void 0 || _localStorage6.setItem(constants.PERSISTED.isWorklistCollapsed, "true");
        // Reset full width worklist when collapsing
        if (isFullWidthWorklist) {
          setIsFullWidthWorklist(false);
        }
      } else {
        var _localStorage7;
        (_localStorage7 = localStorage) === null || _localStorage7 === void 0 || _localStorage7.removeItem(constants.PERSISTED.isWorklistCollapsed);
      }
    }
  }, [isWorklistCollapsed]);
  useEffect(function () {
    if (typeof window !== "undefined") {
      if (isSummaryCollapsed) {
        var _localStorage8;
        (_localStorage8 = localStorage) === null || _localStorage8 === void 0 || _localStorage8.setItem(constants.PERSISTED.isSummaryCollapsed, "true");
      } else {
        var _localStorage9;
        (_localStorage9 = localStorage) === null || _localStorage9 === void 0 || _localStorage9.removeItem(constants.PERSISTED.isSummaryCollapsed);
      }
    }
  }, [isSummaryCollapsed]);

  // useEffect(() => {
  //   if (isOnPremise && isFullWidthWorklist) {
  //     getUnsyncCount().then((unsync_count) => {
  //       setUnsyncCount(unsync_count);
  //     });
  //   }
  // }, [isOnPremise, isFullWidthWorklist]);

  useEffect(function () {
    if (!isEmpty(currentPatient)) {
      var is_license_expired = get(currentPatient, ["is_license_expired"], false);
      findMatchingPatient(currentPatientUid);
      Store.update(function (s) {
        s.hasLicenseExpiredForSelectedPatient = is_license_expired;
      });
    }
  }, [currentPatientUid]);

  // Clear next steps when patient changes so SuggestedActions shows the button for the new patient
  useEffect(function () {
    if (currentPatientUid) {
      setNextSteps(null);
    }
  }, [currentPatientUid]);
  var getFilterParams = function getFilterParams(_filters) {
    var _filters$data;
    var filterParams = _objectSpread({}, (_filters$data = _filters === null || _filters === void 0 ? void 0 : _filters.data) !== null && _filters$data !== void 0 ? _filters$data : {});
    var startDate = get(filterParams, ["start_study_date"], "");
    var endDate = get(filterParams, ["end_study_date"], "");
    if (startDate) {
      var startDateVal = new Date(startDate);
      var endDateVal = add(new Date(endDate), {
        days: 1
      });
      if (isValidDate(startDateVal) && isValidDate(endDateVal)) {
        startDateVal.setHours(0, 0, 0);
        endDateVal.setHours(0, 0, 0);
        set(filterParams, ["start_study_date"], startDateVal.toISOString());
        set(filterParams, ["end_study_date"], endDateVal.toISOString());
      }
    }
    if (isLC) {
      // Only set source to selectedWorkspace if no sites are selected in filters
      if (!filterParams.source || filterParams.source === "") {
        filterParams.source = selectedWorkspace === null || selectedWorkspace === void 0 ? void 0 : selectedWorkspace.id;
      }
    }
    return filterParams;
  };
  var updatePatientUnreadCount = function updatePatientUnreadCount(currentPatientUid, hasNewMessage) {
    var patients = get(patientsData, ["data", "content"], []);
    var currentPatient = patients && patients.find(function (p) {
      return get(p, ["patient_uid"], 0) == currentPatientUid;
    });
    var count = 0;
    if (hasNewMessage) {
      count = get(currentPatient, ["unread_message_count"], 0) + 1;
    }
    if (currentPatient) {
      set(currentPatient, ["unread_message_count"], count);
      set(currentPatient, ["has_unread_message"], hasNewMessage);
      if (!isOnPremise) {
        set(currentPatient, ["sync_status", "cloud", "status"], constants.SYNC_STATUS.CLOUD.READ);
      }
    }
  };
  var getPatientsByEmergency = function getPatientsByEmergency(_patients) {
    var _emergencyPatients = [];
    var _nonEmergencyPatients = [];
    _patients.forEach(function (_pat) {
      if (get(_pat, ["emergency"], false) === true) {
        _emergencyPatients.push(_pat);
      } else {
        _nonEmergencyPatients.push(_pat);
      }
    });
    return {
      _emergencyPatients: _emergencyPatients,
      _nonEmergencyPatients: _nonEmergencyPatients
    };
  };
  var formPatientStateObject = function formPatientStateObject(_patients, _patientsData) {
    if (_patientsData) {
      var content = Object.assign(_patientsData, {
        data: _objectSpread(_objectSpread({}, _patientsData.data), {}, {
          content: _patients
        })
      });
      return content;
    }
    return _patientsData;
  };
  var updatePatientList = function updatePatientList(patientsData, _emergencyPatients) {
    var patientIds = _emergencyPatients.map(function (_pat) {
      return _pat.patient_uid;
    });
    var _patientsData = clone(patientsData);
    var _patients = get(_patientsData, ["data", "content"], []);
    _patients = _patients.filter(function (_pat) {
      return !patientIds.includes(_pat.patient_uid);
    });
    _patients = [].concat(_toConsumableArray(_emergencyPatients), _toConsumableArray(_patients));
    return formPatientStateObject(_patients, _patientsData);
  };
  var handleRemovePatient = function handleRemovePatient(patient_uid) {
    var _patientsData = clone(patientsData);
    var _patients = get(_patientsData, ["data", "content"], []);
    var patientToUpdateIdx = _patients.findIndex(function (p) {
      return p.patient_uid === patient_uid;
    });
    var newPatients = _patients.filter(function (p) {
      return p.patient_uid !== patient_uid;
    });
    var updatedPatientData = formPatientStateObject(newPatients, _patientsData);
    if (patientToUpdateIdx >= 0 && patientToUpdateIdx < _patients.length - 1) {
      var _newPatient = _patients[patientToUpdateIdx + 1];
      router.push("/lungcancer/".concat(_newPatient.patient_uid));
    } else if (patientToUpdateIdx === _patients.length - 1) {
      router.push("/lungcancer");
    }
    setPatientsData(updatedPatientData);
  };
  var findMatchingPatient = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_patientUid) {
      var matches;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            if (!_patientUid) {
              _context4.n = 2;
              break;
            }
            _context4.n = 1;
            return getMatchingPatient(_patientUid);
          case 1:
            matches = _context4.v;
            setMatchingPatients(matches);
          case 2:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return function findMatchingPatient(_x4) {
      return _ref5.apply(this, arguments);
    };
  }();
  var relocateEmergencyPatient = function relocateEmergencyPatient(_patients, _targetPatient) {
    var _allPatientsList = _patients.filter(function (pat) {
      return pat.patient_uid != (_targetPatient === null || _targetPatient === void 0 ? void 0 : _targetPatient.patient_uid);
    });
    var _getPatientsByEmergen = getPatientsByEmergency(_allPatientsList),
      _emergencyPatients = _getPatientsByEmergen._emergencyPatients,
      _nonEmergencyPatients = _getPatientsByEmergen._nonEmergencyPatients;
    var hasEmergencyActivated = _targetPatient.emergency;
    if (hasEmergencyActivated) {
      // when emergency is activated
      var nextPatientIndex = _emergencyPatients.findIndex(function (_pat) {
        return _pat.last_image_study_uploaded_at && _targetPatient.last_image_study_uploaded_at && new Date(_pat.last_image_study_uploaded_at) < new Date(_targetPatient.last_image_study_uploaded_at);
      });
      if (nextPatientIndex >= 0) {
        _emergencyPatients = [].concat(_toConsumableArray(_emergencyPatients.slice(0, nextPatientIndex)), [_targetPatient], _toConsumableArray(_emergencyPatients.slice(nextPatientIndex)));
      } else {
        _emergencyPatients.push(_targetPatient);
      }
    } else {
      // when emergency is deactivated
      var _nextPatientIndex = _nonEmergencyPatients.findIndex(function (_pat) {
        return _pat.last_image_study_uploaded_at && _targetPatient.last_image_study_uploaded_at && new Date(_pat.last_image_study_uploaded_at) < new Date(_targetPatient.last_image_study_uploaded_at);
      });
      if (_nextPatientIndex >= 0) {
        _nonEmergencyPatients = [].concat(_toConsumableArray(_nonEmergencyPatients.slice(0, _nextPatientIndex)), [_targetPatient], _toConsumableArray(_nonEmergencyPatients.slice(_nextPatientIndex)));
      } else if (count <= 10) {
        _nonEmergencyPatients.push(_targetPatient);
      }
    }
    _allPatientsList = [].concat(_toConsumableArray(_emergencyPatients), _toConsumableArray(_nonEmergencyPatients));
    return {
      _allPatientsList: _allPatientsList,
      _emergencyPatients: _emergencyPatients,
      _nonEmergencyPatients: _nonEmergencyPatients
    };
  };
  var getSuggestedNextSteps = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          try {
            if (currentPatientUid) {
              suggestedNextSteps.mutateAsync({
                tz_info: new Intl.DateTimeFormat().resolvedOptions().timeZone
              });
              setNextSteps(null);
            }
          } catch (error) {
            console.log("Failed to get suggested next steps");
          }
        case 1:
          return _context5.a(2);
      }
    }, _callee5);
  })), [suggestedNextSteps, currentPatientUid]);
  useEffect(function () {
    if (wsData) {
      var filterObj = localStorage.getItem(constants.PERSISTED.filterObj);
      var isFilterApplied = filters === null || filters === void 0 ? void 0 : filters.isFilterApplied;
      if (filterObj) {
        var _JSON$parse;
        isFilterApplied = (_JSON$parse = JSON.parse(filterObj)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.isFilterApplied;
      }
      if (wsData.action == "new_message" || wsData.action == "update_message" || wsData.action == "unsubscribe" || wsData.action == "subscribe") {
        var _unreadMessages = clone(unreadMessages);
        if (wsData.action == "new_message") {
          var msgContent = get(wsData, ["content"], {});
          var msgPatientUid = get(msgContent, ["patient_uid"], 0);
          // --- Kept this code for future use ---
          // const msgsList = _unreadMessages[msgPatientUid] || []
          // msgsList.unshift(msgContent)
          set(_unreadMessages, [msgPatientUid], [msgContent]); // [...msgsList]
          if (get(msgContent, ["user"], "") !== userId && msgPatientUid != currentPatientUid) {
            updatePatientUnreadCount(msgPatientUid, true);
          }
          if ((get(msgContent, ["image_report_uid"], 0) > 0 || get(msgContent, ["image_study_uid"], 0) > 0) && msgPatientUid === currentPatientUid && isPatientsPage) {
            Store.update(function (s) {
              s.enableViewerAPICall = false;
              s.enableSidebarAPICall = false;
              s.hasUpdatedStudy = true;
            });
            setTimeout(function () {
              Store.update(function (s) {
                s.enableSidebarAPICall = true;
              });
            }, 500);
          }
          if (msgPatientUid === currentPatientUid) {
            setNextSteps(null);
          }
        }
        if (wsData.action == "update_message") {
          var _msgContent = get(wsData, ["content"], {});
          setUpdatedMessage(_msgContent);
        }
        if (wsData.action == "unsubscribe") {
          var _msgPatientUid = get(wsData, ["patient_uid"], 0);
          set(_unreadMessages, [_msgPatientUid], []);
        }
        if (wsData.action == "subscribe") {
          var _msgPatientUid2 = get(wsData, ["patient_uid"], 0);
          updatePatientUnreadCount(_msgPatientUid2);
        }
        setUnreadMessages(_unreadMessages);
      }
      if (wsData.action == "new_patient") {
        var newPatient = get(wsData, ["content"], {});
        var _newPatientId = get(newPatient, ["patient_id"], "");
        var _newPatientUid = get(newPatient, ["patient_uid"], "");
        var _patientsData = clone(patientsData);
        var _patients = get(patientsData, ["data", "content"], []);
        var _getPatientsByEmergen2 = getPatientsByEmergency(_patients),
          _emergencyPatients = _getPatientsByEmergen2._emergencyPatients,
          _nonEmergencyPatients = _getPatientsByEmergen2._nonEmergencyPatients;
        var _updatePatientList = function _updatePatientList() {
          _nonEmergencyPatients.unshift(newPatient);
          var updatedPatientData = formPatientStateObject([].concat(_toConsumableArray(_emergencyPatients), _toConsumableArray(_nonEmergencyPatients)), _patientsData);
          setPatientsData(updatedPatientData);
          setCount(count + 1);
        };

        // If filter is applied then check if new patient should be added at the top of worklist
        if (isFilterApplied) {
          var params = getPatientsCountV2Payload();
          params.filters = params.filters.map(function (filter) {
            return _objectSpread(_objectSpread({}, filter), {}, {
              patient_pk: _newPatientUid
            });
          });
          getPatientsV2(params).then(function (_patientsData) {
            var _filteredPatientCount = get(_patientsData, ["data", "count"], "");
            if (_filteredPatientCount) {
              _updatePatientList();
            }
          });
        } else {
          _updatePatientList();
        }

        // for auto selecting newly registered patient by user
        if (newPatientId && _newPatientId && newPatientId === _newPatientId) {
          if (isMobile) {
            var workList = document.getElementById("worklist-container");
            if (workList) {
              workList["scrollTop"] = 0;
            }
          } else {
            router.push("/patients/".concat(_newPatientUid)).then(function () {
              Store.update(function (s) {
                s.isFormSelectorVisible = isFormModalOpen;
              });
            });
          }
          Store.update(function (s) {
            s.newPatientId = "";
          });
        }
      }
      if (wsData.action === "new_emergency" || wsData.action === "update_emergency") {
        var newPatientEmergencyContent = get(wsData, ["content"], {});
        var patientId = get(newPatientEmergencyContent, ["patient_id"]);
        var stale = get(newPatientEmergencyContent, ["stale"], false);
        var _patientsData2 = clone(patientsData);
        var _patients2 = get(_patientsData2, ["data", "content"], []);
        // let _emergencyPatients: Partial<Patient>[] = clone(emergencyPatients);

        if (wsData.action === "update_emergency") {
          var _selectedEmergencyPatient = _patients2.find(function (_pat) {
            return _pat.patient_uid === patientId;
          });
          if (_selectedEmergencyPatient) {
            _selectedEmergencyPatient.emergency = !stale;
            _selectedEmergencyPatient.emergency_details = stale ? null : newPatientEmergencyContent;
            if (stale) {
              var _relocateEmergencyPat = relocateEmergencyPatient(_patients2, _selectedEmergencyPatient),
                _allPatientsList = _relocateEmergencyPat._allPatientsList,
                _emergencyPatients2 = _relocateEmergencyPat._emergencyPatients;
              _patients2 = _allPatientsList;
              setEmergencyPatients(_emergencyPatients2);
            }
          }
          if (currentPatient && _selectedEmergencyPatient && (currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.patient_uid) === _selectedEmergencyPatient.patient_uid) {
            setCurrentPatient(_objectSpread({}, _selectedEmergencyPatient));
          }
        } else if (wsData.action === "new_emergency") {
          var updatedPatient = _patients2.find(function (_pat) {
            return _pat.patient_uid === patientId;
          }) || {};
          if (!isEmpty(updatedPatient)) {
            updatedPatient = _objectSpread(_objectSpread({}, updatedPatient), {}, {
              emergency: !stale,
              emergency_details: newPatientEmergencyContent
            });
            var _relocateEmergencyPat2 = relocateEmergencyPatient(_patients2, updatedPatient),
              _allPatientsList2 = _relocateEmergencyPat2._allPatientsList,
              _emergencyPatients3 = _relocateEmergencyPat2._emergencyPatients;
            _patients2 = _allPatientsList2;
            setEmergencyPatients(_emergencyPatients3);
          } else {
            getPatientDetails(patientId).then(function (resp) {
              updatedPatient = get(resp, ["data"], {});
              if (!isEmpty(updatedPatient)) {
                var _relocateEmergencyPat3 = relocateEmergencyPatient(_patients2, updatedPatient),
                  _allPatientsList3 = _relocateEmergencyPat3._allPatientsList,
                  _emergencyPatients4 = _relocateEmergencyPat3._emergencyPatients;
                _patients2 = _allPatientsList3;
                setEmergencyPatients(_emergencyPatients4);
                var _updatedPatientData = formPatientStateObject(_patients2, _patientsData2);
                setPatientsData(_updatedPatientData);
              }
            })["catch"](function () {
              Toast.error("New emergency activated for a patient. Please refresh your worklist");
            });
          }
        }
        var updatedPatientData = formPatientStateObject(_patients2, _patientsData2);
        setPatientsData(updatedPatientData);
      }
      if (wsData.action == "update_patient") {
        if (!isFilterApplied) {
          var _patientsData3 = clone(patientsData);
          var _newPatient2 = get(wsData, ["content"], {});
          var _patients3 = get(_patientsData3, ["data", "content"], []);
          var patientToUpdateIdx = _patients3.findIndex(function (p) {
            return p.patient_uid === _newPatient2.patient_uid;
          });
          if (patientToUpdateIdx >= 0) {
            var oldPatient = _patients3[patientToUpdateIdx];
            if (_newPatient2.last_image_study_uploaded_at && oldPatient.last_image_study_uploaded_at !== _newPatient2.last_image_study_uploaded_at) {
              _patients3 = _patients3.filter(function (_pat) {
                return _pat.patient_uid !== _newPatient2.patient_uid;
              });
              var _getPatientsByEmergen3 = getPatientsByEmergency(_patients3),
                _emergencyPatients5 = _getPatientsByEmergen3._emergencyPatients,
                _nonEmergencyPatients2 = _getPatientsByEmergen3._nonEmergencyPatients;
              _patients3 = [].concat(_toConsumableArray(_emergencyPatients5), [_newPatient2], _toConsumableArray(_nonEmergencyPatients2));
            } else {
              _patients3[patientToUpdateIdx] = _newPatient2;
            }
            var _updatedPatientData2 = formPatientStateObject(_patients3, _patientsData3);
            setPatientsData(_updatedPatientData2);
            if ((currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.patient_uid) === (_newPatient2 === null || _newPatient2 === void 0 ? void 0 : _newPatient2.patient_uid)) {
              if (_newPatient2 !== null && _newPatient2 !== void 0 && _newPatient2.custom_tags) {
                setPatientTags(_newPatient2.custom_tags);
              }
              if (_newPatient2 !== null && _newPatient2 !== void 0 && _newPatient2.reminders) {
                setRemindersData(_newPatient2.reminders);
              }
              setCurrentPatient(_newPatient2);
            }
          }
        } else {
          setWorklistUpdated(true);
        }
      }
      if (wsData.action === "export_download_started") {
        Store.update(function (s) {
          s.showExportUpdate = true;
          s.downloadProgress = wsData.progress;
          s.exportGenFailed = false;
        });
      }
      if (wsData.action === "export_download_progress") {
        Store.update(function (s) {
          s.isExportReady = false;
          s.exportGenFailed = false;
          s.downloadProgress = wsData.progress;
        });
      }
      if (wsData.action === "export_generation_complete") {
        Store.update(function (s) {
          s.isExportReady = true;
          s.exportGenFailed = false;
          s.exportTimestamp = wsData.timestamp;
          s.downloadProgress = wsData.progress;
        });
        // Api call to download the Export file
        downloadFile();
      }
      if (wsData.action === "export_download_failed") {
        Store.update(function (s) {
          s.showExportUpdate = true;
          s.isExportReady = false;
          s.exportGenFailed = true;
          s.exportTimestamp = wsData.timestamp;
          s.downloadProgress = wsData.progress;
        });
      }
      if (wsData.action === "patient_file_deletion") {
        Store.update(function (s) {
          s.patientsFileDeletionStatus = wsData.status;
        });
      }
      if (wsData.action === "sync_status_live_update") {
        Store.update(function (s) {
          s.worklistSyncStatus = get(wsData, ["content"], {});
        });
      }
      if (wsData.action === "patient_summary") {
        var summaryData = {
          patient_id: wsData.patient_id,
          summary: wsData.content.summary,
          last_updated_at: wsData.content.last_updated_at
        };
        setWsSummaryData(summaryData);
      }
      if (wsData.action === "sync_status_cloud_update") {
        var _syncStatus = get(wsData, ["content"], {});
        var workspace_name = get(_syncStatus, ["workspace_name"], "");
        var kind = get(_syncStatus, ["kind"], "");
        var last_synced_at = get(_syncStatus, ["last_synced_at"], "");
        if (workspace_name && kind == "success") {
          var _worklistCloudSyncStatus = cloneDeep(worklistCloudSyncStatus);
          var currentWorkspace = _worklistCloudSyncStatus[workspace_name];
          if (currentWorkspace) {
            currentWorkspace.payload = {
              kind: kind,
              last_synced_at: last_synced_at,
              workspace_name: workspace_name
            };
            _worklistCloudSyncStatus[workspace_name] = currentWorkspace;
            Store.update(function (s) {
              s.worklistCloudSyncStatus = _worklistCloudSyncStatus;
            });
          }
        }
      }
      if (wsData.action === "next_steps" && !isEmpty(wsData.content)) {
        var _wsData$content;
        var nextStepsData = wsData === null || wsData === void 0 || (_wsData$content = wsData.content) === null || _wsData$content === void 0 ? void 0 : _wsData$content.next_steps;
        if (wsData.patient_id === (currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.patient_uid)) {
          setNextSteps(nextStepsData);
        }

        // Store next_steps in sessionStorage for multiple patients
        if (typeof window !== "undefined" && nextStepsData) {
          var storedNextSteps = sessionStorage.getItem(constants.PERSISTED.nextSteps);
          var allPatientsNextSteps = {};

          // Parse existing data if it exists
          if (storedNextSteps) {
            try {
              allPatientsNextSteps = JSON.parse(storedNextSteps);
            } catch (error) {
              console.error("Failed to parse existing next_steps:", error);
              allPatientsNextSteps = {};
            }
          }

          // Update/add next_steps for the current patient
          allPatientsNextSteps[wsData.patient_id] = nextStepsData;

          // Save back to sessionStorage
          sessionStorage.setItem(constants.PERSISTED.nextSteps, JSON.stringify(allPatientsNextSteps));
        }
      }
      if (wsData.action === "rad_report_data_extraction") {
        var _wsData$content2;
        // This socket event indicates that the radiology report data has changed and should be refetched.
        // To achieve this, trigger a custom event the RadiologyReportMessage can listen for, carrying any needed identifiers.
        var event = new CustomEvent("radReportDetailsRefetch", {
          detail: {
            patient_id: wsData === null || wsData === void 0 ? void 0 : wsData.patient_id,
            image_study_report_uid: wsData === null || wsData === void 0 || (_wsData$content2 = wsData.content) === null || _wsData$content2 === void 0 ? void 0 : _wsData$content2.id
          }
        });
        window.dispatchEvent(event);
      }
      if (wsData.action === "letter_template_query_response") {
        if (wsData.patient_id === (currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.patient_uid)) {
          Store.update(function (s) {
            s.letterTemplateQueryResponse = get(wsData, ["content"], {});
          });
        }
      }
      if (wsData.action === "new_workspace_referral") {
        setPendingReferral([].concat(_toConsumableArray(pendingReferral), [get(wsData, ["content", "details"], {})]));
      }
      if (wsData.action === "workspace_referral_closed") {
        setPendingReferral(pendingReferral.filter(function (referral) {
          var _wsData$content3, _wsData$content4;
          return referral.referral_id !== get(wsData, ["content", "referral_id"], 0) && (wsData === null || wsData === void 0 || (_wsData$content3 = wsData.content) === null || _wsData$content3 === void 0 ? void 0 : _wsData$content3.status) !== 0 && (wsData === null || wsData === void 0 || (_wsData$content4 = wsData.content) === null || _wsData$content4 === void 0 ? void 0 : _wsData$content4.status) !== 1;
        }));
      }
      if (wsData.action === "workspace_referral_updated") {
        var _wsData$content5;
        if ((wsData === null || wsData === void 0 || (_wsData$content5 = wsData.content) === null || _wsData$content5 === void 0 ? void 0 : _wsData$content5.status) === 2) {
          refetchUserWorkspace();
        }
        setPendingRequest(pendingRequest.filter(function (request) {
          var _wsData$content6, _wsData$content7;
          return request.referral_id !== get(wsData, ["content", "referral_id"], 0) && (wsData === null || wsData === void 0 || (_wsData$content6 = wsData.content) === null || _wsData$content6 === void 0 ? void 0 : _wsData$content6.status) !== 0 && (wsData === null || wsData === void 0 || (_wsData$content7 = wsData.content) === null || _wsData$content7 === void 0 ? void 0 : _wsData$content7.status) !== 1;
        }));
      }
    }
  }, [wsData]);
  return /*#__PURE__*/React.createElement(PatientsContext.Provider, {
    value: {
      patientsData: patientsData,
      setPatientsData: setPatientsData,
      getPatientData: getPatientData,
      getPatientCount: getPatientCount,
      updatePatientUnreadCount: updatePatientUnreadCount,
      updatedMessage: updatedMessage,
      setUpdatedMessage: setUpdatedMessage,
      unreadMessages: unreadMessages,
      setUnreadMessages: setUnreadMessages,
      currentPatient: currentPatient,
      setCurrentPatient: setCurrentPatient,
      getFilterParams: getFilterParams,
      lastId: lastId,
      setLastId: setLastId,
      isPatientsLoading: isPatientsLoading,
      setPatientsLoading: setPatientsLoading,
      filters: filters,
      setFilters: setFilters,
      count: count,
      // unsyncCount,
      isCountLoading: isCountLoading,
      setIsFullWidthWorklist: setIsFullWidthWorklist,
      isFullWidthWorklist: isFullWidthWorklist,
      matchingPatients: matchingPatients,
      setMatchingPatients: setMatchingPatients,
      savedFilterData: savedFilterData,
      setSavedFilterData: setSavedFilterData,
      handleRemovePatient: handleRemovePatient,
      selectedWorkspace: selectedWorkspace,
      setSelectedWorkspace: setSelectedWorkspace,
      worklistUpdated: worklistUpdated,
      setWorklistUpdated: setWorklistUpdated,
      sortParams: sortParams,
      setSortParams: setSortParams,
      socket: socket,
      wsData: wsData,
      patientTags: patientTags,
      setPatientTags: setPatientTags,
      getPatientTags: getPatientCustomTags,
      isPatientTagsLoading: isPatientTagsLoading,
      remindersData: remindersData,
      setRemindersData: setRemindersData,
      wsSummaryData: wsSummaryData,
      setWsSummaryData: setWsSummaryData,
      nextSteps: nextSteps,
      emrRecordsData: emrRecordsData,
      setEmrRecordsData: setEmrRecordsData,
      getSuggestedNextSteps: getSuggestedNextSteps,
      pendingReferral: pendingReferral,
      pendingRequest: pendingRequest,
      hasAppliedDefaultFilters: hasAppliedDefaultFilters,
      setHasAppliedDefaultFilters: setHasAppliedDefaultFilters,
      filtersExplicitlyCleared: filtersExplicitlyCleared,
      setFiltersExplicitlyCleared: setFiltersExplicitlyCleared,
      userWorkspaces: workspaceData,
      refetchUserWorkspace: refetchUserWorkspace,
      savedFilters: savedFilters,
      getSavedFiltersCount: getSavedFiltersCount
    }
  }, children);
};